export const shortenString = (text, length, prefix = '...') => {
  return text?.length > length ? text?.slice(0, length) + prefix : text;
};
